const convertType = (type) => {
  switch (type) {
    case "전체" :
      return null;
    case "법인" :
      return "NORMAL";
    case "개인" :
      return "INDIVIDUAL";
    case null :
      return "전체";
    case "NORMAL" :
      return "법인";
    case "INDIVIDUAL" :
      return "개인";
  }
}
const formatDateWithoutT = (date) => {
  if(!date) return;
  return date.replace('T', ' ').substring(0, 19);
}

//a,b 모두 영어 또는 숫자값인지 판별
const bothAreNumOrEng = (a,b) => {
  //숫자로 된 문자열 판별식 (e.g. "10" => true)
  const isNumChar = (val) => {
    return !!Number(val)
  }
  //영어로 시작하는 문자열 판별식
  const isEngChar = (val) => {
    return val.toUpperCase().charCodeAt() >=65 && val.toUpperCase().charCodeAt() <= 90
  }

  return (isNumChar(a) || isNumChar(b)) && (isEngChar(b) || isEngChar(a))
}

const customSort = (arr) => {
  let result;
  //특수문자 > 숫자 > 영어 > 한글 순으로 정렬 (유니코드 오름차순 정렬)
  result = arr.sort((a,b)=>{
    if (a.name > b.name) return 1; 
    if (a.name < b.name) return -1; 
    return 0;
  })
  //특수문자 > 영어 > 숫자 > 한글 순으로 정렬 (요청사항 반영)
  result = arr.sort((a,b)=>{
    if (bothAreNumOrEng(a.name,b.name)) {
      if (a.name > b.name) return -1 
      if (a.name < b.name) return 1
    } 
  })
  return result
}

export { convertType, formatDateWithoutT, bothAreNumOrEng, customSort }